const CHROMIUM_REGEX = /Chrome|Chromium|Edg/;
const OPERA_REGEX = /Opera|OPR/;

export function isChromium(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }

  return (
    CHROMIUM_REGEX.test(navigator.userAgent) &&
    !OPERA_REGEX.test(navigator.userAgent)
  );
}
